import React from 'react'
import { Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import SampleCell from '../../SkuGroupTable/columns/@components/SampleCell'
import { skuGroupUserModalFilters } from '../../@signals'


export default function groupsColumn() {
    return {
        name: 'groupSample', label: 'SKU Groups',
        options: {
            sort: false,
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center', maxWidth: 260 } }),
            customBodyRowRenderLite: (value, row) => (
                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
                    <SampleCell sample={value || []} total={row.numGroups} />
                    <IconSeeker
                        icon="pen"
                        tooltip="Edit groups"
                        sx={{ fontSize: '0.875rem', cursor: 'pointer', color: 'text.secondary' }}
                        onClick={() => {
                            skuGroupUserModalFilters.value = {
                                userID: row.userID,
                                userName: row.userName,
                                customerID: row.customerID,
                                groupIDs: row.groupIDs || [],
                            }
                        }}
                    />
                </Box>
            ),
        }
    }
}
